export const ppcColors = {
  primary: '#F79E1B', //PPC yellow
  secondary: '#FF5F00', //PPC orange
  lightPrimary: '#F79E1B80',
  grey: '#84817D',
  darkGrey: '#242423',
};

export const breakpointValues = {
  large: 664,
  xl: 1430,
};

export const breakpointQueries = {
  largerViewportHeight: `(min-height:${breakpointValues.large}px)`,
  xlViewportWidth: `(min-width:${breakpointValues.xl}px)`,
};

export const breakpoints = {
  largerViewportHeight: `@media ${breakpointQueries.largerViewportHeight}`,
  xlViewportWidth: `@media ${breakpointQueries.xlViewportWidth}`,
};
